/**
 * Constants for Floodgate
 */ export var FloodgateActivity = /*#__PURE__*/ function(FloodgateActivity) {
    FloodgateActivity["MyDay"] = "MyDay";
    FloodgateActivity["MyTasks"] = "MyTasks";
    FloodgateActivity["MyTasksNewExperience"] = "MyTasksNewExperience";
    FloodgateActivity["MyPlans"] = "MyPlans";
    FloodgateActivity["PageHeader"] = "PageHeader";
    return FloodgateActivity;
}({});
